import { CommonModule } from '@angular/common'
import { Component, Inject, ViewEncapsulation } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { RouterModule } from '@angular/router'
import { AngularMaterialsModules } from 'src/app/module/materials.module'
import { CommonInfoService } from 'src/app/service/common-info/common-info.service'
import { DdcLoggerService } from 'src/app/service/log/ddc-logger.service'
import { Media } from '../../enums/enums'
import { DdcRotatingBorderCardComponent } from '../ddc-rotating-border-card/ddc-rotating-border-card.component'
@Component({
  selector: 'ddc-info-card-dialog',
  templateUrl: './ddc-info-card-dialog.component.html',
  styleUrls: ['./ddc-info-card-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [AngularMaterialsModules, CommonModule, RouterModule, DdcRotatingBorderCardComponent],
})
export class DdcInfoCardDialogComponent {
  media_path = Media.ASSETS

  constructor(
    private logger: DdcLoggerService,
    private common_info: CommonInfoService,
    private dialogRef: MatDialogRef<DdcInfoCardDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { stepData: any[]; finishedStep: number },
  ) {}

  closeStepper(): void {
    this.common_info.add_stage(this.data.finishedStep).subscribe((res: any) => {})
    this.dialogRef.close()
  }
}
